import http from '@/assets/js/http'
import {
  baseSmile
} from '@/assets/js/base-url.js'


export default {
  namespaced: true,
  state: {
    searchLoading: false,
    apiUrl: `${baseSmile}/business-catelog/`,
    bizcatelog: [],
    bizAllHeader: [],
    errorMsg: '',
    dbTable: [],
    bizFieldSuggestions: []
  },
  mutations: {
    setBizCatelog(state, newVal) {
      state.bizcatelog = newVal
    },
    addBizCatelog(state, item) {
      state.bizcatelog.push(item)
    },
    delBizCatelog(state, itemId) {
      state.bizcatelog = state.bizcatelog.filter(item => item.id != itemId)
    },
    setSearchLoading(state, newVal) {
      state.searchLoading = newVal
    },
    setBizAllHeader(state, newVal) {
      state.bizAllHeader = newVal
    },
    setDbTable(state, newVal) {
      state.dbTable = newVal
    },
    setSuggestions(state, newVal) {
      state.bizFieldSuggestions = newVal
    }
  },
  actions: {
    CBizCatelog(ctx, formData) {
      http.post(ctx.state.apiUrl, formData).then(resp => {
        this._vm.$notify({
          title: 'success',
          message: 'Bizlog Sumbited',
          type: 'success',
          duration: 5000
        })
        ctx.commit("addBizCatelog", resp.data)
      }).catch(error => {
        this._vm.$notify({
          title: 'error',
          message: '操作失败，请联系Golden PIPE Ion 寻求帮助',
          type: 'error',
          duration: 5000
        })
      });

    },
    UBizCatelog(ctx, formData) {
      http.put(ctx.state.apiUrl + formData.id + '/', formData).then(resp => {
        this._vm.$notify({
          title: 'success',
          message: 'Bizlog Updated',
          type: 'success',
          duration: 5000
        })
        ctx.dispatch('getBizCatelog', {})
      }).catch(error => {
        this._vm.$notify({
          title: 'error',
          message: '操作失败，请联系Golden PIPE Ion 寻求帮助',
          type: 'error',
          duration: 5000
        })
      });
    },
    DBizCatelog(ctx, id) {
      http.delete(ctx.state.apiUrl + id + '/', '').then(resp => {
        this._vm.$notify({
          title: 'success',
          message: 'Bizlog Deleted',
          type: 'success',
          duration: 5000
        })
        ctx.commit("delBizCatelog", id)
      }).catch(error => {
        this._vm.$notify({
          title: 'error',
          message: '操作失败，请联系Golden PIPE Ion 寻求帮助',
          type: 'error',
          duration: 5000
        })
      });
    },
    getBizCatelog(ctx, filterData) {
      ctx.commit('setSearchLoading', true)
      http.get(ctx.state.apiUrl, filterData).then(resp => {
        ctx.commit('setBizCatelog', resp.data)
      }).catch(error => {
        console.error('Error', error)
      }).finally(() => {
        ctx.commit('setSearchLoading', false)
      });
    },
    getBizAllHeader(ctx) {
      ctx.commit('setSearchLoading', true)
      http.get(`${baseSmile}/table-configs/`, {
        table_name: 'business_catelog'
      }).then(resp => {
        ctx.commit('setBizAllHeader', resp.data)
        ctx.dispatch('getBizCatelog')
      }).catch(error => {
        console.error('Error', error)
      }).finally(() => {
        ctx.commit('setSearchLoading', false)
      })
    },
    getDbTable(ctx) {
      http.get(`${baseSmile}/db-tables/`).then(resp => {
        ctx.commit('setDbTable', resp.data)
      }).catch(error => {
        console.error('Error', error)
      })
    },
    operationBizCatelog(ctx, ids) {
      http.put(ctx.state.apiUrl + 'operation/', ids).then(resp => {
        ctx.dispatch('getBizCatelog', {})
        this._vm.$notify({
          title: 'success',
          message: 'Operation Success',
          type: 'success',
          duration: 5000
        })
      }).catch(error => {
        console.error('Error', error)
      })
    },
    querySearchAsync(ctx, {
      queryString,
      callback = () => {}
    }) {
      return http.get(ctx.state.apiUrl, {
          business_field__icontains: queryString
        })
        .then(response => {
          ctx.commit('setSuggestions', response.data)
          callback(response.data)
        })
        .catch(error => {
          console.error(error)
          callback([])
        })
    },
    debounceQuerySearch(ctx, {
      queryString,
      callback
    }) {
      clearTimeout(window._debounceTimer)
      window._debounceTimer = setTimeout(() => {
        ctx.dispatch('querySearchAsync', {
          queryString,
          callback
        })
      }, 1500)
    },
  },
  getters: {
    relatedFieldList(state) {
      return state.bizFieldSuggestions.reduce((acc, obj) => {
        const transformItems = obj.technical_fields.map(item => ({
          id: item.id,
          end_user_field: item.end_user_field
        }))
        return acc.concat(transformItems)
      }, [])
    }
  },
  modules: {}
}



// WEBPACK FOOTER //
// ./src/store/smile/smile_bizcatelog.js